module.exports = __webpack_public_path__ + "static/img/16@2x.c5c0569f.png";